import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useHistory, useLocation } from "react-router-dom";

export default function CheckDepositExpired() {
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const onConfirmMessage = () => {
    if (queryParams.has("mrdc_expired")) {
      queryParams.delete("mrdc_expired");
      history.replace("/invoices");
    }
  };

  return (
    <AlertDialog open={queryParams.has("mrdc_expired")}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Deposit time exceeded</AlertDialogTitle>
          <AlertDialogDescription>
            Your deposit was not submitted. Please try again.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={onConfirmMessage}>
            Close
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
